var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuroHt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 42,
    viewBox: "0 0 36 42",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m21.7167969 2.89355469-1.0253907 4.6875c-.5859374-.26367188-1.875-.703125-3.6621093-.703125-2.8857422 0-4.8632813 1.30371093-5.8447266 3.29589841h8.3789063l-.2490235 1.171875h-8.5693359c-.1904297.6738281-.2783203 1.3916016-.2783203 2.1533203 0 .1904297 0 .366211.0146484.5419922h8.2617188l-.2490235 1.171875h-7.7929687c.6152343 1.9921875 2.4755859 3.1640625 5.9033203 3.1640625.6298828 0 1.7138672-.102539 2.0654297-.2490234l-1.0400391 4.7753906c-.3955078.0878906-1.3330078.234375-2.109375.234375-6.40136718 0-10.48828124-2.9882812-11.07421874-7.9248047h-2.44628906l.24902344-1.171875h2.12402344c0-.0292968 0-.0732422 0-.102539 0-.8935547.07324218-1.7578125.234375-2.5927735h-1.78710938l.24902344-1.171875h1.81640625c1.40625-4.84863279 5.56640621-8.1738281 11.52832031-8.1738281 2.5048828 0 4.6289063.5859375 5.3027344.89355469z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    height: "142.6%",
    width: "145.6%",
    x: "-15.2%",
    y: "-14.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter4",
    result: "shadowMatrixOuter4",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter5",
    result: "shadowMatrixOuter5",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter6",
    result: "shadowMatrixOuter6",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter7",
    result: "shadowMatrixOuter7",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter4"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter5"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter6"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m15.1884766 37.1376953h-2.5429688l.703125-3.2929687h-2.859375l-.70312499 3.2929687h-2.54296875l1.79882813-8.4550781h2.54296871l-.6914062 3.2285156h2.859375l.6914062-3.2285156h2.5429688zm5.7011718 0h-2.484375l1.3769532-6.4863281h-2.3496094l.421875-1.96875h7.1835937l-.421875 1.96875h-2.3496093z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    height: "206.4%",
    width: "150.6%",
    x: "-16.9%",
    y: "-35.5%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter4",
    result: "shadowMatrixOuter4",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter5",
    result: "shadowMatrixOuter5",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter6",
    result: "shadowMatrixOuter6",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter7",
    result: "shadowMatrixOuter7",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter4"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter5"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter6"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter7"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e00017",
    fillRule: "evenodd",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e00017",
    fillRule: "evenodd",
    xlinkHref: "#c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroHt);
export default __webpack_public_path__ + "static/media/euro_ht.8130cc7f4da9f499e9c8ed02595833ba.svg";
export { ForwardRef as ReactComponent };